import React from "react";
import OverlayHome from "./components/OverlayHome";
import FeaturedCollections from "./components/FeaturedCollections";
import TrendingNow from "./components/TrendingNow";
import AudioSeries from "./components/AudioSeries";
import EbooksHome from "./components/EbooksHome";
import Top10AudioSeries from "./components/TopTenAudioSeries";
import Footer from "../common/UI/Footer";
import NewsLetter from "../common/UI/NewsLetter";
import TrendingVideos from "./components/VideosHome";
import SeriesTopTen from "./components/SeriesTopTen";
import AudiobookGrid from "./components/BooksGrid";
import ShortsCarousel from "./components/ShortsCarousel";
import style from "./components/Css/Homestyles.module.css";
import AudioBookCarousel from "./components/AudioBookCarousel";
import ImageSliderr from "./components/SliderHomepage";
import styles from "./HomePageMain.module.css";
import DocumentarySection from "../pages/video-pages/DocumentarySection";
import KidStoriesSection from "../pages/video-pages/KidStoriesSection";
import GarhwaliCarousel from "./components/GarhwaliScroller";
import RecentlyAddedCarousel from "./components/RecentlyUploaded";
import Banner from "./components/BannerPage";

function Homepage() {
  return (
    <>
      <div className={style.homeBackground}>
        <OverlayHome type={"Home"} category={"audio"} />
        <div className={`${styles.homepageContainer} ${styles.contentOverlap}`}>
          <FeaturedCollections />
          <RecentlyAddedCarousel />
          <TrendingNow />
          <AudioSeries />
          <Banner
            desktopImagePath="/banner-desktop.webp"
            mobileImagePath="/banner-mobile.webp"
            altText="Website Banner" 
          />

          <ImageSliderr />
          <ShortsCarousel />
          <EbooksHome />
          <GarhwaliCarousel language={"garhwali"} />
          <DocumentarySection />
          <Top10AudioSeries />
          <AudioBookCarousel />
          <KidStoriesSection />
          <SeriesTopTen />
          <NewsLetter />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Homepage;
